let baseURL;
let baseURL2;
switch (process.env.NODE_ENV) {
    //生产环境
    case 'development':
        // baseURL = '//mtnft-browser.trilliontrust.com/api';
        // baseURL2 = '//mtnft-browser.trilliontrust.com/api';
        baseURL = '/api1';
        baseURL2 = '/api2';
        break;
    //正式环境
    case 'production':
        baseURL = 'http://mtnft-browser.trilliontrust.com/api';
        baseURL2 = 'http://mtnft-browser.trilliontrust.com/api';
        break;
}

export default {
    baseURL,baseURL2
}
